module.exports = __webpack_public_path__ + "static/media/EmailByDonna.645a6af4.svg";